var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 23.146,
    viewBox: "0 0 32 23.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:url(#c);}.d{fill:url(#d);}.e{fill:url(#f);}.f{fill:url(#g);}.g{fill:url(#h);}.h{fill:url(#i);}.i{fill:url(#j);}.j{fill:url(#k);}.k{fill:url(#l);}.l{fill:url(#m);}.m{fill:url(#n);}.n{fill:url(#o);}.o{fill:url(#p);}.p{fill:url(#q);}.q{fill:url(#r);}.r{fill:url(#s);}.s{fill:url(#t);}.t{fill:url(#u);}.u{fill:url(#v);}.v{fill:url(#w);}.w{fill:url(#x);}.x{fill:url(#y);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.342,
    y1: 0.04,
    x2: 0.665,
    y2: 0.952,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.666,
    y1: 0.894,
    x2: 0.207,
    y2: -0.088,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.264,
    y1: 0.155,
    x2: 0.607,
    y2: 0.756,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.5,
    y1: -0.062,
    x2: 0.5,
    y2: 1.035,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -31.823,
    y1: -13.3,
    x2: -31.781,
    y2: -12.495,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -38.212,
    y1: -15.556,
    x2: -38.212,
    y2: -16.648,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbed21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -33.331,
    y1: 5.635,
    x2: -32.603,
    y2: 4.29,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f35227",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f35227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -31.984,
    y1: -14.178,
    x2: -31.941,
    y2: -13.373,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -38.404,
    y1: -16.608,
    x2: -38.404,
    y2: -17.7,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -33.341,
    y1: 5.614,
    x2: -32.613,
    y2: 4.269,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -32.43,
    y1: -12.645,
    x2: -32.388,
    y2: -11.84,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -38.939,
    y1: -14.772,
    x2: -38.939,
    y2: -15.863,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -33.341,
    y1: 5.657,
    x2: -32.614,
    y2: 4.312,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: -32.178,
    y1: -15.073,
    x2: -32.135,
    y2: -14.268,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: -38.636,
    y1: -17.682,
    x2: -38.636,
    y2: -18.773,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: -33.353,
    y1: 5.592,
    x2: -32.625,
    y2: 4.247,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: -33.075,
    y1: -11.993,
    x2: -33.032,
    y2: -11.188,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: -39.711,
    y1: -13.991,
    x2: -39.711,
    y2: -15.083,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: -33.353,
    y1: 5.678,
    x2: -32.626,
    y2: 4.333,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 0.896,
    y1: 0.79,
    x2: -0.501,
    y2: -0.233,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 0.223,
    y1: 0.347,
    x2: 0.899,
    y2: 0.721,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 0.494,
    y1: 0.496,
    x2: -0.154,
    y2: -0.45,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 0.106,
    y1: 0.499,
    x2: -0.851,
    y2: -0.086,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 0.588,
    y1: 0.23,
    x2: 0.234,
    y2: -0.618,
    xlinkHref: "#x"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 -70.555)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M50.252,115.178l-.327-2.186a1.4,1.4,0,0,0-2.286-.86L46.4,113.185a1.036,1.036,0,0,1-1.6-.332l-1.98-4.014a.746.746,0,0,0-1.337,0l-1.98,4.014a1.036,1.036,0,0,1-1.6.332l-1.243-1.053a1.4,1.4,0,0,0-2.286.86l-.327,2.186a1.036,1.036,0,0,1-1.462.786L29.9,114.711a1.4,1.4,0,0,0-1.819,1.944l4.517,8.219H51.7l4.517-8.219a1.4,1.4,0,0,0-1.819-1.944l-2.686,1.252A1.036,1.036,0,0,1,50.252,115.178Z",
    transform: "translate(-26.15 -35.492)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.974,138.38l-.3-1.987a1.278,1.278,0,0,0-2.088-.782l-1.135.957a.949.949,0,0,1-1.46-.3l-1.808-3.649a.682.682,0,0,0-1.222,0l-1.808,3.649a.949.949,0,0,1-1.46.3l-1.135-.957a1.278,1.278,0,0,0-2.088.782l-.3,1.987a.947.947,0,0,1-1.335.714l-2.453-1.138a1.276,1.276,0,0,0-1.662,1.768l4.126,7.472H69.3l4.126-7.472a1.276,1.276,0,0,0-1.662-1.768l-2.453,1.138A.947.947,0,0,1,67.974,138.38Z",
    transform: "translate(-44.574 -57.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M89.569,166.36l-.264-1.748a1.132,1.132,0,0,0-1.847-.688l-1,.842a.842.842,0,0,1-1.292-.266l-1.6-3.21a.605.605,0,0,0-1.08,0l-1.6,3.21a.841.841,0,0,1-1.292.266l-1-.842a1.132,1.132,0,0,0-1.847.688l-.264,1.748a.838.838,0,0,1-1.181.628l-2.17-1a1.125,1.125,0,0,0-1.47,1.555l3.649,6.572H90.741l3.649-6.572a1.125,1.125,0,0,0-1.47-1.555l-2.17,1A.838.838,0,0,1,89.569,166.36Z",
    transform: "translate(-67.024 -84.731)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M93.463,348.113H73.453a1.479,1.479,0,0,1,0-2.958h20.01a1.479,1.479,0,0,1,0,2.958Z",
    transform: "translate(-67.459 -257.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M93.463,395.258H73.453a1.479,1.479,0,0,1,0-2.958h20.01a1.479,1.479,0,0,1,0,2.958Z",
    transform: "translate(-67.459 -301.557)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.623 70.555)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M221.878,72.9a2.376,2.376,0,1,1-2.41-2.342A2.376,2.376,0,0,1,221.878,72.9Z",
    transform: "translate(-217.125 -70.555)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M227.356,78.771a1.983,1.983,0,1,1-2.011-1.954A1.983,1.983,0,0,1,227.356,78.771Z",
    transform: "translate(-222.997 -76.424)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M224.509,74.309a2.377,2.377,0,0,1-3.143,3.233,2.377,2.377,0,1,0,3.143-3.233Z",
    transform: "translate(-221.1 -74.073)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.842 73.951)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M113.816,127.013a2.376,2.376,0,1,1-2.41-2.342A2.376,2.376,0,0,1,113.816,127.013Z",
    transform: "translate(-109.063 -124.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M119.294,132.887a1.983,1.983,0,1,1-2.011-1.954A1.983,1.983,0,0,1,119.294,132.887Z",
    transform: "translate(-114.935 -130.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M116.446,128.425a2.377,2.377,0,0,1-3.143,3.233,2.377,2.377,0,1,0,3.143-3.233Z",
    transform: "translate(-113.037 -128.189)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.561)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M329.94,127.013a2.376,2.376,0,1,1-2.41-2.342A2.376,2.376,0,0,1,329.94,127.013Z",
    transform: "translate(-325.187 -124.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M335.419,132.887a1.983,1.983,0,1,1-2.011-1.954A1.983,1.983,0,0,1,335.419,132.887Z",
    transform: "translate(-331.06 -130.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M332.571,128.425a2.377,2.377,0,0,1-3.143,3.233,2.377,2.377,0,1,0,3.143-3.233Z",
    transform: "translate(-329.162 -128.189)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 77.658)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M4.752,186.106a2.376,2.376,0,1,1-2.41-2.342A2.376,2.376,0,0,1,4.752,186.106Z",
    transform: "translate(0.001 -183.764)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M10.231,191.981a1.983,1.983,0,1,1-2.011-1.954A1.983,1.983,0,0,1,10.231,191.981Z",
    transform: "translate(-5.872 -189.634)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M7.383,187.519a2.377,2.377,0,0,1-3.143,3.233,2.377,2.377,0,1,0,3.143-3.233Z",
    transform: "translate(-3.974 -187.283)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.247 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M439,186.106a2.376,2.376,0,1,1-2.41-2.342A2.376,2.376,0,0,1,439,186.106Z",
    transform: "translate(-434.25 -183.764)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M444.482,191.981a1.983,1.983,0,1,1-2.011-1.954A1.983,1.983,0,0,1,444.482,191.981Z",
    transform: "translate(-440.123 -189.634)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M441.634,187.519a2.377,2.377,0,0,1-3.143,3.233,2.377,2.377,0,1,0,3.143-3.233Z",
    transform: "translate(-438.225 -187.283)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.666 78.254)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M204.714,193.513l-2.734,3.952a.6.6,0,0,0,0,.682l2.734,3.952a.6.6,0,0,0,.985,0l2.734-3.952a.6.6,0,0,0,0-.682l-2.734-3.952A.6.6,0,0,0,204.714,193.513Z",
    transform: "translate(-201.873 -193.254)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M210.956,202.484l-2.395,3.461a.525.525,0,0,0,0,.6L210.956,210a.525.525,0,0,0,.863,0l2.395-3.461a.525.525,0,0,0,0-.6l-2.395-3.461a.525.525,0,0,0-.863,0Z",
    transform: "translate(-208.054 -201.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M218.413,208.264a.468.468,0,0,0-.738-.049c-.01.012-.02.025-.029.038l-2.229,3.221a.947.947,0,0,0,0,1.078l2.126,3.073a.524.524,0,0,0,.631-.186l2.395-3.461a.524.524,0,0,0,0-.6Z",
    transform: "translate(-214.41 -207.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M254.407,202.49a.522.522,0,0,0-.5-.221v7.963a.522.522,0,0,0,.5-.221l2.395-3.461a.525.525,0,0,0,0-.6Z",
    transform: "translate(-250.642 -201.699)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M210.957,269.546a.525.525,0,0,0,.863,0l2.395-3.461a.524.524,0,0,0,.093-.3h-5.839a.524.524,0,0,0,.093.3Z",
    transform: "translate(-208.055 -261.235)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.4600dabc512d45786fbc2508f10fca08.svg";
export { ForwardRef as ReactComponent };